






































































import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "@/plugins";

export default Vue.extend({
  name: "Edit",
  props: {
    project: { type: Object }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      ruleForm: {
        cpuRequests: "",
        memoryRequests: "",
        cpuRequestsUnit: "core",
        memoryRequestsUnit: "Gi",
        cpuLimits: "",
        memoryLimits: "",
        cpuLimitsUnit: "core",
        memoryLimitsUnit: "Gi"
      },
      rules: {
        value: [{ pattern: /^\d*(\.\d+)?$/ }]
      },
      resData: null as any
    };
  },
  methods: {
    show(data?: any) {
      if (data.items.length > 0) {
        this.resData = JSON.parse(JSON.stringify(data.items[0]));

        if (this.resData.spec.limits[0]) {
          this.setForm(this.resData.spec.limits[0]);
        }
      } else {
        this.resData = {
          kind: "LimitRange",
          apiVersion: "v1",
          spec: {
            limits: [
              {
                default: {},
                defaultRequest: {}
              }
            ]
          }
        };
      }

      this.dialog = true;
    },
    setForm(limits: any) {
      const {
        default: { memory, cpu },
        defaultRequest: { memory: m2, cpu: c2 }
      } = limits;

      // 此处判断值，是因为 getValue 无法判断应该返回什么单位
      if (memory) {
        [
          this.ruleForm.memoryLimits,
          this.ruleForm.memoryLimitsUnit
        ] = this.getValue(memory);
      }

      if (cpu) {
        [this.ruleForm.cpuLimits, this.ruleForm.cpuLimitsUnit] = this.getValue(
          cpu
        );
      }
      if (m2) {
        [
          this.ruleForm.memoryRequests,
          this.ruleForm.memoryRequestsUnit
        ] = this.getValue(m2);
      }
      if (c2) {
        [
          this.ruleForm.cpuRequests,
          this.ruleForm.cpuRequestsUnit
        ] = this.getValue(c2);
      }
    },
    getValue(value: string) {
      return [
        parseFloat(value).toString(),
        value.replace(/^\d+(\.\d*)?/, "") || "core"
      ];
    },
    quit() {
      this.ruleForm = {
        cpuRequests: "",
        memoryRequests: "",
        cpuRequestsUnit: "core",
        memoryRequestsUnit: "Gi",
        cpuLimits: "",
        memoryLimits: "",
        cpuLimitsUnit: "core",
        memoryLimitsUnit: "Gi"
      };
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
        this.dialog = false;
      });
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          this.create();
        }
      });
    },

    create() {
      this.buildData();
      if (this.resData.metadata?.name) {
        axios
          .patch(
            `/policy/project/${this.project.id}/limitRanges/${this.resData.metadata.name}`,
            this.resData
          )
          .then(() => {
            this.$message.success("默认资源配置修改成功");
            this.quit();
            this.$emit("afterEdit");
          });
      } else {
        this.resData.metadata = { name: this.project.projectName };
        axios
          .post(`/policy/project/${this.project.id}/limitRanges`, this.resData)
          .then(() => {
            this.$message.success("默认资源配置修改成功");
            this.quit();
            this.$emit("afterEdit");
          });
      }
    },
    buildData() {
      // 如果resData格式不符合就不会修改参数

      this.resData.spec.limits[0].default = {
        memory: `${this.ruleForm.memoryLimits}${this.ruleForm.memoryLimitsUnit}`,
        cpu: `${this.ruleForm.cpuLimits}${
          this.ruleForm.cpuLimitsUnit === "core"
            ? ""
            : this.ruleForm.cpuLimitsUnit
        }`
      };
      this.resData.spec.limits[0].defaultRequest = {
        memory: `${this.ruleForm.memoryRequests}${this.ruleForm.memoryRequestsUnit}`,
        cpu: `${this.ruleForm.cpuRequests}${
          this.ruleForm.cpuRequestsUnit === "core"
            ? ""
            : this.ruleForm.cpuRequestsUnit
        }`
      };
      this.resData.spec.limits[0].type = "Container";
      this.resData.kind = "LimitRange";
      this.resData.apiVersion = "v1";
    }
  }
});
